/* eslint-disable no-use-before-define */
import { ajax, setConfig, getConfig } from '../twd/twd'

export let initTime = async () => {
    try {
        let {data} = await ajax({
            url: '/esb/uit/order/getEstTime?firstLoad=true',
            method: 'GET',
        })

        let now = new Date()
        let est = new Date((await data || {}).est)
        let tz = Math.round((est - now.valueOf())/1000/60/60)
        var eod = new Date(getConfig('end_of_day_time'))
        // eod = new Date(eod.setHours(eod.getHours() + tz))
        var peod = new Date(getConfig('prev_end_of_day_time'))
        // peod = new Date(eod.setHours(eod.getHours() + tz))

        setConfig({
            timezoneOffset: tz,
            startServerTime: new Date(now.setHours(now.getHours() + tz)),

            endOfDayTime: isNaN(eod)
                ? 1700
                : Math.min(eod.getHours() * 100 + eod.getMinutes(), 1700),

            previousEndOfDayTime: isNaN(peod)
                ? 1700
                : Math.min(peod.getHours() * 100 + peod.getMinutes(), 1700),

        })
    } catch(x) {
    }
}





// WEBPACK FOOTER //
// ./src/App/init-time.js